"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeHtml = void 0;
const dompurify = require("dompurify");
const sanitizeHtml = (window, html, emailContentBlacklistedDomains) => {
    const DOMPurify = dompurify(window);
    const reg = new RegExp(emailContentBlacklistedDomains, 'gi');
    return DOMPurify.sanitize(html
        .replace(/<style([\S\s]*?)>([\S\s]*?)<\/style>/gi, '')
        .replace(/<meta([\S\s]*?)>([\S\s]*?)<\/meta>/gi, '')
        .replace(/<script([\S\s]*?)>([\S\s]*?)<\/script>/gi, '')
        .replace(/<input([\S\s]*?)>/gi, '')
        .replace(reg, ''));
};
exports.sanitizeHtml = sanitizeHtml;
//# sourceMappingURL=sanitize-html.js.map